<template>
  <div class="treelister">
    <el-tree
      class="tree"
      :data="data"
      node-key="id"
      accordion
      :default-expand-all="false"
      :indent="0"
      @node-click="btnKey"
      :expand-on-click-node="true"
    >
      <span class="tree-text" slot-scope="{ data }">
        <span class="custom-tree-node" :title="data.label">{{ data.label }}&nbsp;</span>
        <span class="custom-tree-sum">({{data.cnt}})</span>
      </span>
    </el-tree>
  </div>
</template>

<script>

import * as resourceInfo from '@/api/resources/index.js';
import { getInfo} from '@/utils/auth';
export default {
  props: ['isDeptId'],
  data() {
    return {
      data: [],
      deptID: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    btnKey(data) {
      this.$emit('btnKeyst', data.id, data);
    },
    getList() {
      let data = {};
      if(this.$store.state.User.infos){
        data.deptId =JSON.parse(getInfo('infos')).deptId
      }
      resourceInfo.DocumentTypeGetTree(data).then((res) => {
        this.data = res.result;
      });
    },
  },
};
</script>

<style scoped>
.treelister{
  margin-left: 30px;
  margin-top: 20px;
}
.custom-tree-node {
  font-size: 16px;
  max-width:100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
}
.custom-tree-node:hover{
  text-decoration:underline;
}
.custom-tree-sum{
  font-size: 16px;
  display: inline-block;
  position: relative;
  right: 0px;
  top: -4px;
}
.el-tooltip__popper.is-dark {
  font-size: 14px;
}
.hover-color {
  color: #b7b9bf;
  margin-left: 10px;
}
.hover-color:hover {
  color: red;
}

/* 去掉旋转效果 */
/* .el-tree >>> .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
} */

/* 未展开父节点 */
/* .el-tree >>> :not(.is-leaf).el-icon-caret-right:before {
  content: "";
  color: black;
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 100% 100%;
} */

/* 已展开父节点 */
/* .el-tree >>> .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  content: "";
  color: black;
  display: block;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 100% 100%;
} */

/* 子节点 */
.el-tree >>> .is-leaf.el-icon-caret-right:before {
  content: "";
  color: black;
  /* display: block; */
  display: none;
  width: 16px;
  height: 16px;
  font-size: 16px;
  background-size: 100% 100%;
}

/*添加树形结构虚线*/
.el-tree >>> .el-tree__empty-block{
  margin-left: -30px;
}

.treeColor {
  color: #feeb92;
  padding-left: 10px;
}

.tree /deep/.el-tree-node__content {
  height: 40px;
}

.tree  /deep/.el-tree-node {
  position: relative;
  padding-left: 0;
}

.tree  /deep/.el-tree-node__expand-icon {
  font-size: 18px;
  color: #666666;
}

.tree /deep/.el-tree-node__expand-icon.is-leaf {
  color: transparent;
  cursor: default;
}

.tree /deep/.el-tree-node__children {
  padding-left: 19px;
}

.tree /deep/.el-tree-node :last-child:before {
  height: 12px;
}

.tree /deep/.el-tree>.el-tree-node:before {
  border-left: none;
}

.tree-container  /deep/.el-tree>.el-tree-node:after {
  border-top: none;
}

.tree  /deep/.el-tree-node:before {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
  border-left: 1px dotted #666666;
  bottom: 0px;
  height: 100%;
  top: 0px;
  width: 1px;
}

.tree /deep/.el-tree-node:after {
  content: '';
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
  border-top: 1px dotted #666666;
  height: 20px;
  top: 12px;
  width: 10px;
}

.cortext{
  color: blue;
}
</style>